import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { IEpGridModel, EpEventService, IEpGridSelectionOptions, EpGridEvent, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents, PageNames, EpBtContextMenuComponent } from 'ep-bt-controls';
import { FieldAgentClient, Product2 } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

declare var $: any;
import { EpButtonStyle, EpButtonSize, EpButtonType } from '@epicor/kinetic';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-quote-selected-product-grid',
  templateUrl: './epbt-fa-quick-order-quote-selected-product-grid.component.html',
  styleUrls: ['./epbt-fa-quick-order-quote-selected-product-grid.component.scss']
})
export class EpbtFaQuickOrderQuoteSelectedProductGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;
  EpButtonType = EpButtonType;
  products: any;
  public gridModel: IEpGridModel;
  bistrackSettings: any;
  currency: string;
  webTrackUser: any;
  branchId: number;
  selected: any;
  selectedItem: any = [];
  contextMenuItems: any[];

  @Input() deleteFlag = false;
  // @Input() isPopup: boolean = false;
  @Output() onKitEdit: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('decimalTemplate', { static: true }) decimalTemplate: TemplateRef<any>;
  @ViewChild('removeTemplate', { static: true }) removeTemplate: TemplateRef<any>;
  @ViewChild('perTemplate', { static: true }) perTemplate: TemplateRef<any>;
  @ViewChild('quantityTemplate', { static: true }) quantityTemplate: TemplateRef<any>;
  @ViewChild('contextMenu', { static: false }) contextMenu: EpBtContextMenuComponent;

  constructor(private client: FieldAgentClient, private router: Router, private config: BistrackConfig,
    public epEvent: EpEventService, private productService: EpbtFaProductService,
    private quickOrderService: EpbtFaQuickOrderService,
    private fieldAgentService: EpbtFieldAgentService) {
  }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = this.bistrackSettings.baseCurrency.symbol;
      this.gridModel = this.getGridModel([]);
      // this.quickOrderService.prepareData(false);
      this.gridModel.data = this.quickOrderService.quickOrder.Lines.slice();
      // var el = this.gridModel[0].componentElementRef.nativeElement.querySelector('.k-grid-pager .k-state-selected');
      // console.log(el,"elellele")
    });
  }
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }


  getGridModel(productList: any): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'LineNumber',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectable: this.quickOrderService.isNewOrder ? true : false,
      selectionOptions: selectionOptions,
      displayCurrentRow: true,
      columns: [
        { field: 'LineNumber', title: '', width: 30, hidden: true },
        { field: 'code', title: 'CODE', width: 30, hidden: false },
        { field: 'description', title: 'DESCRIPTION', width: 80, hidden: false },
        { field: 'Quantity', title: 'QUANTITY', width: 40, hidden: false, cellTemplate: this.quantityTemplate },
        { field: 'InputPer', title: 'UOM', width: 30, hidden: false, cellTemplate: this.perTemplate },
        { field: 'UnitSellPrice', title: 'PRICE', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
        { field: 'Per', title: 'UOM', width: 30, hidden: false, cellTemplate: this.perTemplate },
        { field: 'Discount1', title: 'DISCOUNT 1', width: 40, hidden: false, cellTemplate: this.decimalTemplate },
        { field: 'Discount2', title: 'DISCOUNT 2', width: 40, hidden: false, cellTemplate: this.decimalTemplate },
        { field: 'TotalSellPrice', title: 'TOTAL', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
        { title: 'DELETE', width: 30, hidden: !this.deleteFlag, class: 'ep-color-red', cellTemplate: this.removeTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.column.displayTitle != 'DELETE' && eventArg.event.type == 'click') {
          this.navigateTo(eventArg.event.dataItem);
        } else if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type === 'contextmenu') {
          if (eventArg.event.dataItem.Product.productSubtype === 4) {// for now only do it for kits
            this.contextMenuItems = this.getContextMenuItems(eventArg.event.dataItem);
            if (this.contextMenuItems.length > 0) {
              this.contextMenu.show(eventArg.event.originalEvent.x, eventArg.event.originalEvent.y);
            }
          }
          eventArg.event.originalEvent.preventDefault();
        }
      },
      // epOnCellClick: (e: IEpComponentEventArg) => {
      //   if (e.event.type === 'contextmenu') {
      //     if (e.event.dataItem.Product.productSubtype === 4) {//for now only do it for kits
      //       this.contextMenuItems = this.getContextMenuItems(e.event.dataItem);
      //       if (this.contextMenuItems.length > 0) {
      //         this.contextMenu.show(e.event.originalEvent.x, e.event.originalEvent.y);
      //       }
      //     }
      //     e.event.originalEvent.preventDefault();
      //   }
      // }
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  // buttonOnClick(){
  //   this.selected = this.gridModel.data.length-1;
  //   //console.log(this.selectionOptions);this.gridModel.data.length-1
  //   this.selectedItem.push(this.selected);
  //   console.log(this.selectedItem);
  //   setTimeout(() => document.querySelector('.k-state-selected').scrollIntoView());
  //   this.updateGridData();
  // }
  // grid height calculation start

  getHeight(): number {
    if (this.quickOrderService.isNewOrder) {
      const height = $(window).outerHeight() - 360; // 593
      const width = parseInt($('body').width());

      if (width > 250 && width < 1023) {
        // mobile and ipad
        return 300;
      }
      return height;

    } else {
      const height = $(window).outerHeight() - 350; // 593
      const width = parseInt($('body').width());

      if (width > 250 && width < 1023) {
        // mobile and ipad
        return 400;
      }
      return height;
    }


  }
  // getHeight(): number {
  //   var height = parseInt($('body').height());

  //   if (height > 900) {
  //     //return 300;
  //     return 600;
  //   }
  //   else return 400;//return 500;
  // }
  // grid height calculation end

  updateGridData() {
    this.gridModel.data = this.quickOrderService.quickOrder.Lines.slice();
  }

  navigateTo(args: any) {


    if (this.productService.shouldTallyProduct(args.Product.tallyLengths)) {
      this.productService.fromPage = PageNames.QuickOrderTalliedProductLineNegotiation;
    } else {
      if (args.ManualOrderLineType) {
        this.productService.fromPage = PageNames.QuickOrderMOLTNegotiation;
      } else {
        this.productService.fromPage = PageNames.QuickOrderLineNegotiation;
      }
    }
    this.productService.selectedProductItem = args.Product;
    // this.productService.fromPage = PageNames.QuickOrderLineNegotiation;
    this.quickOrderService.quickOrderLine = args;
    this.quickOrderService.AddOrEdit = false;
    if (!this.quickOrderService.isNewOrder) {
      this.router.navigate(['/home/product/details', args.Product.productId]);
    } else {
      this.epEvent.broadcast(CustomEvents.NewQuickorderProductTabSelect);
    }

  }

  onCardClick(model) {
    this.navigateTo(model);
  }

  onRemove(dataItem: any) {
    const index = this.quickOrderService.quickOrder.Lines.findIndex(c => c.LineNumber == dataItem);
    if (index >= 0) {
      if (this.quickOrderService.quickOrderLine && this.quickOrderService.quickOrder.Lines[index].LineNumber == this.quickOrderService.quickOrderLine.LineNumber) {
        this.quickOrderService.quickOrderLine = null;
      }
      this.quickOrderService.quickOrder.Lines.splice(index, 1);
      this.gridModel.data = this.quickOrderService.quickOrder.Lines.slice();
    }
  }

  getContextMenuItems(item: any) {
    return [
      {
        text: 'Edit Kit', menuIcon: 'mdi mdi-view-dashboard', onClick: () => {
          this.onKitEdit.emit(item);
        }
      }
    ];
  }
}
